export const QUERY_KEY = "invoices";
